import type { ButtonProps } from '@petsmart-ui/sparky';
import { Button } from '@petsmart-ui/sparky';
import Link from 'next/link';

export type IButtonProps = ButtonProps & {
    isNextLink?: boolean;
};

export function GenericButton({ isNextLink = false, href, ...props }: IButtonProps) {
    const hasValidHref = typeof href === 'string' && href.trim().length > 0;
    const buttonProps = props as ButtonProps;

    if (isNextLink && hasValidHref) {
        return (
            <Link
                href={href}
                prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
            >
                <Button {...buttonProps} />
            </Link>
        );
    }

    if (hasValidHref) {
        return <Button href={href} {...buttonProps} />;
    }

    return <Button {...buttonProps} />;
}
